import { atom } from 'jotai';

export const activeModalIdAtom = atom<string | null>(null);
